<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Nome</th>
        <th>Especie</th>
        <th>Sexo</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(animal, index) in item" :key="animal.id">
        <td>{{ animal.nome }}</td>
        <td>{{ animal.especie }}</td>
        <td>{{ animal.sexo }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: ["item"],
};
</script>
